import { useEffect, useState } from "react";

export default function TikTokCallback() {
  const [msg, setMsg] = useState("Connecting TikTok…");

  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");
    const state = url.searchParams.get("state");
    if (!code || !state) { setMsg("Missing code/state"); return; }

    (async () => {
      try {
        const r = await fetch("https://pqeb47i2j2gtd7f3x5x6y2ojzu0kfpew.lambda-url.us-east-2.on.aws/", {
          // If you're on Next.js API routes, use "/api/tiktok/oauth/callback"
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code, state }),
          // credentials: "include", // uncomment only if your API uses cookies/session
        });

        const json = await r.json().catch(() => ({}));
        if (!r.ok) throw json;

        setMsg("TikTok account connected successfully.");

        // Optional: remove ?code=… from the URL to avoid reusing the code on refresh
        const clean = window.location.origin + window.location.pathname;
        window.history.replaceState({}, "", clean);
      } catch (e) {
        setMsg(`Failed to connect: ${e?.error || "unknown error"}`);
      }
    })();
  }, []);

  return <div className="page"><h2>{msg}</h2></div>;
}
